import { get, updatePatch, create } from "./apiService";

export const getAutoStackStats = async () => {
  try {
    const response = await get(`/api/v1/auto-stacking/auto-stacks/stats`);
    return response;
  } catch (error) {
    throw new Error(`Could not fetch auto-stack stats: ${error.message}`);
  }
};

export const getSingleAutoStackStats = async (stackId) => {
  try {
    const response = await get(
      `/api/v1/auto-stacking/auto-stacks/${stackId}/stats`
    );
    return response;
  } catch (error) {
    throw new Error(`Could not fetch auto-stack stats: ${error.message}`);
  }
};

export const getAutoStackTemplates = async () => {
  try {
    const response = await get("/api/v1/auto-stacking/templates");
    return response;
  } catch (error) {
    throw new Error(`Could not fetch auto-stack templates: ${error.message}`);
  }
};

export const getUserAutoStacks = async () => {
  try {
    const response = await get("/api/v1/auto-stacking/auto-stacks");
    return response;
  } catch (error) {
    throw new Error(`Could not fetch user auto-stacks: ${error.message}`);
  }
};

export const getUserSingleAutoStack = async (stackId) => {
  try {
    const response = await get(`/api/v1/auto-stacking/auto-stacks/${stackId}`);
    return response;
  } catch (error) {
    throw new Error(`Could not fetch user single auto-stack: ${error.message}`);
  }
};

export const updateUserAutoStack = async (stackId, updateData) => {
  try {
    const response = await updatePatch(
      `/api/v1/auto-stacking/auto-stacks/${stackId}`,
      {},
      updateData
    );
    return response;
  } catch (error) {
    throw new Error(`Could not update auto-stack: ${error.message}`);
  }
};

export const addToAutoStack = async (stackId, data) => {
  try {
    const response = await create(
      `/api/v1/auto-stacking/auto-stacks/${stackId}/add`,
      data
    );
    return response;
  } catch (error) {
    throw new Error(`Could not add to auto-stack: ${error.message}`);
  }
};

export const getAutoStackPurchases = async (stackId, page = 1, limit = 10) => {
  try {
    const response = await get(
      `/api/v1/auto-stacking/auto-stacks/${stackId}/purchases?page=${page}&limit=${limit}`
    );
    return response;
  } catch (error) {
    throw new Error(`Could not fetch auto-stack purchases: ${error.message}`);
  }
};
